import { InjectableRxStompConfig } from '@stomp/ng2-stompjs';

export const Config = {
    // production: false,
    serverUrl: 'http://localhost:5000',
    SanUrl: 'http://localhost:81/defaultadmin',
    apiUrl: 'http://localhost:5000/api',

    // serverUrl: 'http://localhost:82/5001',
    // apiUrl: 'http://localhost:82/api/api/api',

    // serverUrl: 'https://iucpq-adt.actiumtec.com',
    // apiUrl: 'https://iucpq-adt.actiumtec.com/api/api/api',
    
    tokenType: 'Bearer',
    sseUrl: 'http://localhost:82/sse-notifications',
    reportUrl: 'https://localhost:5003',
};

export const AdtRxStompConfig: InjectableRxStompConfig = {
    // Which server?
    brokerURL: 'ws://154.70.207.179:15674/ws',
    //brokerURL: 'wss://dev-adt.actiumtechnologie.com:15673/ws',

    // Headers
    // Typical keys: login, passcode, host
    // we must provide non-generic to avoid  "login failed - access_refused (user must access over loopback)""
    // don't forget to change for deployment en prod
    connectHeaders: {
        login: 'svbdev',
        passcode: '**svbdev**2025**',
        //'passcode': 'G4nd4lf_59',
        'client-id': 'plus-angular',
    },

    // How often to heartbeat?
    // Interval in milliseconds, set to 0 to disable
    heartbeatIncoming: 0, // Typical value 0 - disabled
    heartbeatOutgoing: 0, // Typical value 20000 - every 20 seconds

    // Wait in milliseconds before attempting auto reconnect
    // Set to 0 to disable
    // Typical value 5000 (5 seconds)
    reconnectDelay: 200,

    // Will log diagnostics on console
    // It can be quite verbose, not recommended in production
    // Skip this key to stop logging to console
    debug: (msg: string): void => {
        //console.log(new Date(), msg);
    },
};
